export class RegularProduct {
  constructor(data = null) {
    if (data) {
      this.img = data?.galleryImages[0]?.image_url || "";
      this.amwayValue = data.amwayValue || {
        businessVolume: 0, pointValue: 0, returnableBV: 0, returnablePV: 0
      };
      this.prices = data.prices || [{ type: "RETAIL", price: "", currency: { digit: "0", symbol: "฿", ISOCode: "THB" } }]
      this.sku = data.sku || ""
      this.identifier = data.identifier || ""
    }
  }
}

export class RegularProductCategoryList {
  constructor(data = null) {
    if (data) {
      this.data = data?.data?.map((categoryItem) => new RegularProductCategory(categoryItem)) || [];
    }
  }
}

export class RegularProductCategory {
  constructor(data = null) {
    if (data) {
      this.color = data?.color || 'primary';
      this.id = data?.id || '';
      this.image_banner_url = data?.image_banner_url || '';
      this.image_url = data?.image_url || '';
      this.main_banner_image_url = data?.main_banner_image_url || '';
      this.name = data?.name || '';
      this.thumbnail_image_url = data?.thumbnail_image_url || '';
    }
  }
}
export class RegularProductSubCategoryList {
  constructor(data = null) {
    if (data) {
      this.data = data?.data?.subCategory?.map((categoryItem) => new RegularProductSubCategory(categoryItem)) || [];
    }
  }
}

export class RegularProductSubCategory {
  constructor(data = null) {
    if (data) {
      this.id = data?.id || '';
      this.name = data?.name || '';
      this.image_url = data?.image_url || '';
      this.image_banner_url = data?.image_banner_url || '';
      this.sub_category = data?.subCategory?.map(subCat => new RegularProductSubCategory(subCat)) || [];
    }
  }
}
